import { Component, Input, AfterViewInit, ViewChild } from '@angular/core';
import { NgForm, UntypedFormControl } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderLoyaltyService } from '../../../_services/order-loyalty.service';

import moment from 'moment';


@Component({
    selector: 'app-loyalty-registration-form',
    templateUrl: './loyalty-registration-form.component.html',
    styleUrl: './loyalty-registration-form.component.scss',
    standalone: false
})
export class LoyaltyRegistrationFormComponent implements AfterViewInit {
	@ViewChild('regForm') public regForm: NgForm;
	dirty: boolean = false;
	pristine: boolean = false;
	birthDate = new UntypedFormControl(moment());
	anniversary = new UntypedFormControl(moment());

	@Input() public mode;
	@Input() public source;
	@Input() public fields;
	@Input() public required = false;

	$storage;

	constructor(
		public appService: AppService,
		public orderService: OrderService,
		public loyaltyService: OrderLoyaltyService
	) {
		this.$storage = this.orderService.$storage;
	}

	ngAfterViewInit(): void {
		this.regForm.statusChanges.subscribe(result => {
			this.dirty = this.regForm.dirty;
			this.pristine = this.regForm.pristine;
		});
	}

	public submitForm() {
		this.regForm.onSubmit(undefined);
		return this.regForm.valid;
	}

}
